import { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Redirect, useHistory } from 'react-router-dom';
import closeFill from '@iconify/icons-eva/close-fill';
import { Icon } from '@iconify/react';
import useAuth from '../hooks/useAuth';
import useLocales from '../hooks/useLocales';
import { setSuperAdmin } from '../redux/slices/authJwt';
import { PATH_PAGE } from '../routes/paths';
import LoadingScreen from '../components/LoadingScreen';
import { MIconButton } from '../components/@material-extend';
import { Roles } from '../constants/roles.enum';
import { GetFeaturesData } from '../@types/features';
import { RootState } from '../redux/store';

// ----------------------------------------------------------------------

type AuthProtectProps = {
  children: ReactNode;
};

export default function AuthProtect({ children }: AuthProtectProps) {
  const dispatch = useDispatch();
  const { translate } = useLocales();
  const { isLoading, isAuthenticated, user } = useAuth();
  const { featuresPayload } = useSelector((state: RootState) => state.features);
  const history = useHistory();
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  // yasaklılar yaz
  const insideGuard = {
    SuperAdmin: [] as string[],
    Admin: [
      '/dashboard/home',
      '/dashboard/alarm',
      '/dashboard/integration',
      '/dashboard/locations'
    ] as string[],
    User: ['/dashboard/companies', '/dashboard/management'] as string[],
    Fire_Fighter: [
      '/dashboard/home',
      '/dashboard/alarm',
      '/dashboard/integration',
      '/dashboard/locations'
    ] as string[],
    Supervisor: [
      '/dashboard/home',
      '/dashboard/integration',
      '/dashboard/locations'
    ] as string[]
  } as any;
  // insideGuard

  const featureGuard = [
    {
      name: 'face_search',
      path: '/dashboard/faceSearch'
    },
    {
      name: 'employee_productivity',
      path: '/dashboard/employeeProductivityDetail'
    },
    {
      name: 'employee_base',
      path: '/dashboard/addEmployee'
    },
    {
      name: 'zone_productivity',
      path: '/dashboard/zoneProductivityDetail'
    },
    {
      name: 'zone_base',
      path: '/dashboard/addZone'
    }
  ];

  // eger yasakli ise dasboard root'a yonlendircek
  /* if (
    user.roles.length &&
    (user.roles.includes(Roles.SUPERADMIN) || user.roles.includes('superadmin'))
  ) {
    dispatch(setSuperAdmin());
  } */

  // if (featuresLoading) {
  //   return <LoadingScreen />;
  // }


  if (
    (user.roles.length && user.roles.includes(Roles.SUPERADMIN)) ||
    user.roles.includes('superadmin')
  ) {
    dispatch(setSuperAdmin());
    if (insideGuard.SuperAdmin.includes(history.location.pathname)) {
      enqueueSnackbar(translate('global.you.are.not.authorized'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      // return <Redirect to={PATH_DASHBOARD.root} />;
      return <Redirect to={PATH_PAGE.page404} />;
    }
  }

  if (user && user.roles.length && user.roles.includes(Roles.ADMIN)) {
    if (
      !user.isSuperior &&
      insideGuard.Admin.includes(history.location.pathname)
    ) {
      enqueueSnackbar(translate('global.you.are.not.authorized'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      // return <Redirect to={PATH_DASHBOARD.root} />;
      return <Redirect to={PATH_PAGE.page404} />;
    }
  }

  if (user && user.roles.length && user.roles.includes(Roles.FIRE_FIGHTER)) {
    if (
      !user.isSuperior &&
      insideGuard.Fire_Fighter.includes(history.location.pathname)
    ) {
      enqueueSnackbar(translate('global.you.are.not.authorized'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      // return <Redirect to={PATH_DASHBOARD.root} />;
      return <Redirect to={PATH_PAGE.page404} />;
    }
  }
  if (user && user.roles.length && user.roles.includes(Roles.SUPERVISOR)) {
    if (
      !user.isSuperior &&
      insideGuard.Supervisor.includes(history.location.pathname)
    ) {
      enqueueSnackbar(translate('global.you.are.not.authorized'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      // return <Redirect to={PATH_DASHBOARD.root} />;
      return <Redirect to={PATH_PAGE.page404} />;
    }
  }

  if (user && user.roles.length && (user.roles.includes(Roles.USER) || user.roles.includes(Roles.CLIENT_ADMIN))) {
    if (
      !user.isSuperior &&
      insideGuard.User.includes(history.location.pathname)
    ) {
      enqueueSnackbar(translate('global.you.are.not.authorized'), {
        variant: 'error',
        action: (key) => (
          <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            <Icon icon={closeFill} />
          </MIconButton>
        )
      });
      // return <Redirect to={PATH_DASHBOARD.root} />;
      return <Redirect to={PATH_PAGE.page404} />;
    }


    if (featuresPayload) {
      const featureName = featureGuard.find((feature) => feature.path === history.location.pathname);

      if (featureName) {
        const feature = featuresPayload.find((feature: GetFeaturesData) => feature.codeName === featureName.name);
        if (!feature) {
          enqueueSnackbar(translate('global.you.are.not.authorized'), {
            variant: 'error',
            action: (key) => (
              <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                <Icon icon={closeFill} />
              </MIconButton>
            )
          });
          return <Redirect to={PATH_PAGE.page404} />;
        }
      }
    }
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
}
